<template lang="pug">
a(:href='storeUrl' target='_blank' style="max-width:140px")
	img(src="/img/app_store_badge.svg", alt="iOS", title="iOS")
</template>

<script>
export default {
	computed: {
		storeUrl() {
			return 'https://itunes.apple.com/it/app/id1502549000?mt=8' //this.iosId
		}
	}
}
</script>
